import { handleActions } from 'redux-actions';
import { SEARCH_USERS_SUCCESS, SEARCH_WORKERS_SUCCESS, CLEAR_WORKERS_PREDICTIONS_LIST, SEARCH_EMPLOYERS_SUCCESS,
  CLEAR_EMPLOYERS_PREDICTIONS_LIST, SET_WORKERS_PREDICTIONS_LIST } from '../actions/actionTypes';

const initialState = {
  usersPredictionsList: [],
  workersPredictionsList: [],
  employersPredictionsList: []
};

export default handleActions(
  {
    [SEARCH_USERS_SUCCESS]: (state, action) => ({
      ...state,
      usersPredictionsList: action.users
    }),
    [SEARCH_WORKERS_SUCCESS]: (state, action) => ({
      ...state,
      workersPredictionsList: action.workers
    }),
    [SET_WORKERS_PREDICTIONS_LIST]: (state, action) => ({
      ...state,
      workersPredictionsList: action.workers
    }),
    [CLEAR_WORKERS_PREDICTIONS_LIST]: (state) => ({
      ...state,
      workersPredictionsList: []
    }),
    [SEARCH_EMPLOYERS_SUCCESS]: (state, action) => ({
      ...state,
      employersPredictionsList: action.employers
    }),
    [CLEAR_EMPLOYERS_PREDICTIONS_LIST]: (state) => ({
      ...state,
      employersPredictionsList: []
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/users.js